import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useResourceCapacityPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, resourceId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _resourceId = isRef<string>(resourceId) ? resourceId : ref<string>(resourceId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		resourceId: _resourceId,
		...useQuery(() => new q.ResourceCapacityPageQueryV1(_workspaceId.value, _strategyId.value, _resourceId.value))
	}
	return {
		...result,
		runResourceCapacityPageQueryV1: result.run,
		modelResourceCapacityPageQueryV1: result.model,
	}
}

export function useResourcesByStrategyIdQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.ResourcesByStrategyIdQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runResourcesByStrategyIdQueryV1: result.run,
		modelResourcesByStrategyIdQueryV1: result.model,
	}
}

export function useResourceUnitCostsQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.ResourceUnitCostsQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runResourceUnitCostsQueryV1: result.run,
		modelResourceUnitCostsQueryV1: result.model,
	}
}

